import {
  createListenerMiddleware as reduxCreateListenerMiddleware,
  addListener as reduxAddListener, removeListener as reduxRemoveListener,
  type TypedAddListener,
  type TypedRemoveListener,
} from '@reduxjs/toolkit';
import { type RootState, type AppDispatch } from '../../store';

export const listenerMiddleware = reduxCreateListenerMiddleware();

export type AddListener = TypedAddListener<RootState, AppDispatch>;
export const addListener = reduxAddListener as AddListener;

export type RemoveListener = TypedRemoveListener<RootState, AppDispatch>;
export const removeListener = reduxRemoveListener as RemoveListener;
